/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc. For more information, please email contact@hellobulb.com.
*/
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isLastByKey',
  standalone: false,
})
export class IsLastByKeyPipe implements PipeTransform {
  // eslint-disable-next-line class-methods-use-this
  transform(items: any[], item: any, key: string): boolean {
    if (typeof item[key] === 'object') {
      throw new Error(`IsLastByKeyPipe: item[${key}] must be not an object.`);
    }
    return !!items.length && !!item[key] && items[items.length - 1][key] === item[key];
  }
}
